import React, { useEffect, useState } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { validateSession } from '../services/apiClient';
import '../pages/LoginPage.css';

const ProtectedLayout = () => {
  const [isChecking, setIsChecking] = useState(true);
  const [isAuthorized, setIsAuthorized] = useState(false);

  const renderLogoLoader = () => (
    <div className="mini-logo-loader" role="status" aria-live="polite" aria-label="Loading">
      <span className="loader-orbit loader-orbit-one"></span>
      <span className="loader-orbit loader-orbit-two"></span>
      <span className="loader-orbit loader-orbit-three"></span>
      <img
        src={process.env.PUBLIC_URL + '/images/logo.png'}
        alt="Company Logo"
        className="session-loader-logo"
      />
    </div>
  );

  useEffect(() => {
    const runValidation = async () => {
      const logoutRequested =
        localStorage.getItem('logoutRequested') === 'true' ||
        sessionStorage.getItem('logoutRequested') === 'true';

      if (logoutRequested) {
        setIsAuthorized(false);
        setIsChecking(false);
        return;
      }

      try {
        const valid = await validateSession();
        setIsAuthorized(valid);
      } catch {
        setIsAuthorized(false);
      } finally {
        setIsChecking(false);
      }
    };

    runValidation();
  }, []);

  if (isChecking) {
    return (
      <main style={{ minHeight: '100vh', display: 'grid', placeItems: 'center' }}>
        {renderLogoLoader()}
      </main>
    );
  }

  if (!isAuthorized) {
    return <Navigate to="/login" replace />;
  }

  return <Outlet />;
};

export default ProtectedLayout;